


























import { Component, Vue, Prop } from 'vue-property-decorator'
import html2canvas from 'html2canvas'
import store from '@/store/store'
import SupportPopup from '@/components/popups/SupportPopup.vue'
import downloadAppFunc from '@/shared/functions/downloadAppFunc'
import LogService from '@/api/broadcast/LogService'

@Component({
  components: {
    SupportPopup
  }
})

export default class PageHeaderComponent extends Vue {
  @Prop() public header!: string;
  @Prop() public hideLeftBtn?: boolean;
  @Prop() public closeIcon!: boolean;
  @Prop() public hideSupportBtn?: boolean;
  @Prop() public emitClose?: boolean;

  private imageScreenshot: any = ''
  public showSupport = false
  private isDesktop = false;

  public created () {
    this.isDesktop = downloadAppFunc.checkIfDesktop()
  }

  public async openSupportPopup () {
    try {
      const screenHeight: number = window.innerHeight <= 900 ? window.innerHeight : 800
      const screenWidth: number = window.innerWidth <= 450 ? window.innerWidth : 450
      html2canvas(document.body, {
        useCORS: true,
        // windowHeight: screenHeight,
        // windowWidth: screenWidth,
        // scrollY: -(window.scrollY),
        y: window.scrollY,
        height: screenHeight
        // width: screenWidth
      }).then(async (canvas) => {
        try {
          this.imageScreenshot = await canvas.toDataURL('image/jpeg', 1)
          this.showSupport = true
          store.saveSupportData({ img: this.imageScreenshot, enableImg: true, title: this.$route.name })
        } catch (error) {
          LogService.LogError(`Error with getting support screenshot ${error}`, {})
        }
      })
    } catch (error) {
      LogService.LogError(`Error with opening support ${error}`, {})
    }
  }

  public async closeSupportPopup () {
    this.showSupport = false
  }

  public async openAeroguestSupport () {
    this.$router.push({ name: 'support', params: this.$route.params })
  }

  public async skipAndGetApp () {
    if (this.isDesktop) {
      this.$router.push({ name: 'downloadapppage' })
    } else {
      await downloadAppFunc.checkOS()
    }
  }

  public navigate () {
    if (this.emitClose) {
      this.$emit('close')
    } else {
      this.$router.go(-1)
    }
  }
}
